import React from "react";
import { bool } from "prop-types";

const VerificationNotice = ({ shouldShow }) => {
  return shouldShow ? (
    <div className="tw-flex tw-w-f tw-mx-auto tw-overflow-hidden tw-my-5 tw-bg-white tw-rounded-lg tw-shadow-lg">
      <div className="tw-flex tw-items-center tw-justify-center tw-w-12 tw-bg-blue-500">
        <svg
          className="tw-w-6 tw-h-6 tw-text-white tw-fill-current"
          viewBox="0 0 40 40"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM21.6667 28.3333H18.3334V25H21.6667V28.3333ZM21.6667 21.6666H18.3334V11.6666H21.6667V21.6666Z" />
        </svg>
      </div>
      <div className="tw-px-4 tw-py-1">
        <div className="mx-3">
          <span className="tw-font-semibold tw-text-blue-500">
            Important Notice
          </span>
          <p className="tw-text-sm tw-text-gray-600">
            Please make sure to refresh this page after verifying your email
            address.
          </p>
        </div>
      </div>
    </div>
  ) : null;
};

VerificationNotice.propTypes = {
  shouldShow: bool,
};
VerificationNotice.defaultProps = {
  shouldShow: false,
};
export default VerificationNotice;
